
    import { Component, Vue } from 'vue-property-decorator';
    

    @Component
    export default class OtherPartyNotSpouseFaqDropdown extends Vue {
        showAssistance = false;
    }
